export const categories = [
  {
    slug: 'cansibei',
    name: '蚕丝被护理',
    description: '蚕丝被因其天然蛋白纤维特性，对清洗方式有严格要求。了解蚕丝被的正确干洗流程，避免缩水、变硬、失去蓬松感。',
    icon: 'ri-shirt-line',
    image: 'https://readdy.ai/api/search-image?query=Premium%20silk%20comforter%20on%20a%20clean%20white%20bed%20with%20soft%20natural%20lighting%2C%20luxurious%20texture%20visible%2C%20minimalist%20bedroom%20setting%2C%20elegant%20product%20photography%20with%20warm%20cream%20background%2C%20high%20detail%20fabric%20texture%2C%20professional%20interior%20design%20aesthetic&width=800&height=600&seq=cat-cansi-01&orientation=landscape',
    color: 'bg-accent-100 text-accent-900',
  },
  {
    slug: 'yurongbei',
    name: '羽绒被干洗',
    description: '羽绒被蓬松保暖，但清洗不当会导致羽绒结块、失去保暖性。掌握专业羽绒被干洗技巧，让被子持久如新。',
    icon: 'ri-cloud-line',
    image: 'https://readdy.ai/api/search-image?query=Fluffy%20white%20down%20comforter%20draped%20over%20a%20modern%20bed%2C%20soft%20morning%20sunlight%20streaming%20through%20window%2C%20cozy%20bedroom%20with%20neutral%20tones%2C%20premium%20bedding%20photography%2C%20clean%20and%20inviting%20atmosphere%2C%20high%20quality%20fabric%20detail&width=800&height=600&seq=cat-yurong-01&orientation=landscape',
    color: 'bg-primary-100 text-primary-900',
  },
  {
    slug: 'mianbei',
    name: '棉被清洁',
    description: '棉被吸湿性强，容易滋生细菌和螨虫。了解棉被的专业清洁方式，守护家人健康睡眠。',
    icon: 'ri-sun-line',
    image: 'https://readdy.ai/api/search-image?query=Cotton%20comforter%20neatly%20folded%20on%20a%20light%20wooden%20surface%2C%20warm%20natural%20lighting%2C%20clean%20minimalist%20home%20setting%2C%20organic%20texture%20of%20cotton%20fabric%20visible%2C%20hygienic%20and%20fresh%20aesthetic%2C%20professional%20product%20photography&width=800&height=600&seq=cat-mian-01&orientation=landscape',
    color: 'bg-secondary-100 text-secondary-900',
  },
  {
    slug: 'maotan',
    name: '毛毯清洗',
    description: '毛毯材质多样，羊毛毯、羊绒毯、混纺毯各有不同的清洗方法。学会正确护理，保持毛毯柔软亲肤。',
    icon: 'ri-contrast-drop-2-line',
    image: 'https://readdy.ai/api/search-image?query=Soft%20luxurious%20wool%20blanket%20draped%20elegantly%20over%20a%20reading%20chair%2C%20warm%20afternoon%20light%2C%20cozy%20home%20interior%20with%20plants%2C%20premium%20textile%20photography%2C%20cream%20and%20beige%20color%20palette%2C%20inviting%20texture%20detail&width=800&height=600&seq=cat-mao-01&orientation=landscape',
    color: 'bg-accent-100 text-accent-900',
  },
  {
    slug: 'beixin',
    name: '被芯保养',
    description: '被芯日常保养是延长被子寿命的关键。掌握晾晒、收纳、防潮等基础保养知识，让被子始终蓬松柔软。',
    icon: 'ri-heart-line',
    image: 'https://readdy.ai/api/search-image?query=Collection%20of%20various%20folded%20bedding%20comforters%20in%20different%20materials%20on%20open%20shelving%2C%20organized%20and%20tidy%20storage%2C%20natural%20light%2C%20home%20organization%20aesthetic%2C%20clean%20minimalist%20interior%2C%20professional%20home%20care%20photography&width=800&height=600&seq=cat-bx-01&orientation=landscape',
    color: 'bg-primary-100 text-primary-900',
  },
  {
    slug: 'meinvbei',
    name: '美女被干洗',
    description: '高档美女被采用精梳棉与天丝混纺面料，需要专业级干洗护理。了解美女被的专属洗护方案，保持奢华质感。',
    icon: 'ri-vip-crown-line',
    image: 'https://readdy.ai/api/search-image?query=Luxury%20high%20end%20comforter%20with%20elegant%20jacquard%20pattern%20on%20a%20five%20star%20hotel%20bed%2C%20golden%20hour%20lighting%2C%20sophisticated%20bedroom%20decor%2C%20premium%20bedding%20detail%20shot%2C%20opulent%20yet%20tasteful%20aesthetic%2C%20professional%20interior%20photography&width=800&height=600&seq=cat-mnv-01&orientation=landscape',
    color: 'bg-secondary-100 text-secondary-900',
  },
];

export const allArticles = [
  {
    slug: 'cansibei-ganxi-quan-gonglve',
    title: '蚕丝被干洗全攻略：专业护理让蚕丝被多用5年',
    excerpt: '蚕丝被以其轻盈柔软、亲肤透气著称，但错误的清洗方式会让昂贵的蚕丝被毁于一旦。本文详解蚕丝被干洗的正确流程与注意事项。',
    category: 'cansibei',
    categoryName: '蚕丝被护理',
    date: '2026-07-20',
    readTime: '8分钟',
    author: '被护专家',
    image: 'https://readdy.ai/api/search-image?query=Close%20up%20of%20luxurious%20silk%20comforter%20texture%20with%20soft%20sheen%2C%20delicate%20fabric%20detail%2C%20professional%20dry%20cleaning%20theme%2C%20clean%20white%20background%2C%20elegant%20product%20photography%2C%20warm%20cream%20lighting%2C%20high%20end%20textile%20aesthetic&width=800&height=500&seq=art-cansi-01&orientation=landscape',
    content: {
      intro: '蚕丝被是高档寝具中的佼佼者，由天然桑蚕丝制成，具有极佳的透气性、保暖性和亲肤性。然而蚕丝蛋白纤维结构娇贵，清洗护理稍有不慎就会导致缩水、变硬、发黄等问题。掌握正确的蚕丝被干洗方法，可以让您的蚕丝被保持蓬松柔软，使用寿命延长至8-10年。',
      sections: [
        {
          heading: '蚕丝被为什么不能水洗？',
          content: '蚕丝的主要成分是丝素蛋白，遇水后会膨胀，纤维结构容易被破坏。水洗后的蚕丝被容易出现以下问题：纤维断裂导致被子变薄、缩水严重体积减小20%-30%、失去天然光泽变得暗淡、蓬松度大幅下降变得硬板。此外，家用洗衣机的高速旋转会对蚕丝纤维造成不可逆的机械损伤。因此专业干洗是蚕丝被护理的最佳选择。',
        },
        {
          heading: '专业蚕丝被干洗流程',
          content: '专业的蚕丝被干洗服务通常包含以下步骤：第一步是全面检查，技师会检查蚕丝被的面料状况、污渍类型和分布位置，确认适合干洗处理。第二步是预处理，对局部顽固污渍进行针对性预处理，使用专业去渍剂轻柔处理。第三步进入干洗机清洗，采用石油干洗溶剂，低温短时洗涤，保护蚕丝蛋白不受损伤。第四步是轻柔烘干，在低温环境下缓慢烘干，确保蚕丝纤维不因高温受损。最后一步是整形整理，手工拍打恢复蓬松度，整理边角确保被子形状规整。',
        },
        {
          heading: '蚕丝被日常保养技巧',
          content: '定期晾晒是蚕丝被保养的基础，但需注意在通风阴凉处晾晒，避免阳光直射，每次2-3小时即可。使用1-2周后轻拍被子表面恢复蓬松度。收纳时使用透气棉布袋而非真空压缩袋，放置在干燥通风的衣柜中，可放入竹炭包或干燥剂防潮。日常使用建议套上纯棉被套，减少蚕丝被直接接触汗渍和皮脂，延长干洗周期。',
        },
        {
          heading: '蚕丝被干洗频率建议',
          content: '一般情况下蚕丝被建议每1-2年进行一次专业干洗。如果被子出现明显异味、局部变色或污渍增多，则应提前安排清洗。被套建议每1-2周更换清洗，这样可以有效减少蚕丝被本体的清洗频率，延长被子寿命。',
        },
      ],
      conclusion: '蚕丝被是值得用心呵护的高品质寝具。选择专业干洗服务、做好日常保养，您的蚕丝被将始终保持最初的柔软蓬松，为您带来年复一年的舒适睡眠体验。',
    },
    faq: [
      { question: '蚕丝被可以用家用干洗剂吗？', answer: '不建议。家用干洗剂成分和浓度与专业设备不匹配，局部处理容易留下水渍印，且无法彻底清除残留溶剂，可能对蚕丝纤维造成持续损伤。' },
      { question: '蚕丝被干洗后会缩水吗？', answer: '专业干洗不会导致明显缩水。劣质干洗或水洗是缩水的主要原因。选择有资质的专业干洗店，使用石油溶剂低温清洗，蚕丝被尺寸基本不变。' },
      { question: '蚕丝被多久干洗一次合适？', answer: '建议每1-2年干洗一次。如果日常使用被套且保持清洁，2年一次即可。如果被子有明显异味或污渍，应提前安排清洗。' },
    ],
  },
  {
    slug: 'yurongbei-ganxi-jiqiao',
    title: '羽绒被干洗技巧大全：避免结块与保暖性下降',
    excerpt: '羽绒被蓬松保暖深受喜爱，但不正确的清洗会导致羽绒结块、保暖性能大打折扣。掌握这些专业干洗技巧，让羽绒被持久温暖。',
    category: 'yurongbei',
    categoryName: '羽绒被干洗',
    date: '2026-07-15',
    readTime: '6分钟',
    author: '被护专家',
    image: 'https://readdy.ai/api/search-image?query=Premium%20white%20down%20comforter%20floating%20softly%2C%20showing%20incredible%20loft%20and%20fluffiness%2C%20studio%20photography%20with%20soft%20diffused%20lighting%2C%20pure%20white%20and%20cream%20background%2C%20professional%20product%20photography%2C%20capturing%20lightweight%20airy%20texture%2C%20luxury%20bedding%20aesthetic&width=800&height=500&seq=art-yurong-01&orientation=landscape',
    content: {
      intro: '羽绒被凭借超强的保暖性和轻盈的体感，成为寒冷季节的睡眠首选。但羽绒被的清洗一直是困扰许多家庭的难题——水洗容易导致羽绒结块、干洗不当又会损伤羽绒的天然油脂。本文将为您揭秘羽绒被专业干洗的正确方法。',
      sections: [
        {
          heading: '羽绒被干洗 vs 水洗：该怎么选？',
          content: '对于高品质羽绒被（含绒量80%以上），专业干洗是更安全的选择。干洗溶剂不会让羽绒吸水膨胀，避免了水洗后羽绒结块的风险。但需要注意，干洗必须使用专门的羽绒干洗程序和温和溶剂，普通干洗可能会过度脱脂，导致羽绒失去弹性和保暖性。对于含绒量较低的羽绒被，可以选择专业水洗配合彻底烘干。',
        },
        {
          heading: '羽绒被专业干洗关键步骤',
          content: '首先是检测评估，技师会检测羽绒被的含绒量、面料密度和破损情况。接着进行局部处理，对领口、边角等易脏部位进行重点预处理。然后进入核心干洗环节，使用温和型石油溶剂，低温短时清洗，保留羽绒天然油脂。干洗后进行分段低温烘干，温度严格控制在50°C以下，分3-4个阶段逐步烘干，每个阶段间隔拍打松散羽绒。最后是蓬松恢复，技师手工反复拍打，使羽绒均匀分布恢复蓬松状态。',
        },
        {
          heading: '羽绒被日常使用与保养',
          content: '日常使用时一定要套上纯棉被套，减少羽绒被直接接触皮肤油脂和汗渍。每周轻轻拍打被子表面帮助羽绒保持蓬松均匀。选择晴朗干燥天气在通风处晾晒2-3小时，切忌暴晒。收纳时使用透气收纳袋，不要使用真空压缩袋以免破坏羽绒结构。存放时放入防虫防潮剂，置于干燥通风处。',
        },
        {
          heading: '如何判断羽绒被是否需要干洗？',
          content: '出现以下情况时您的羽绒被需要安排干洗：被子出现明显异味或霉味、羽绒分布不均出现大面积空洞、面料出现发黄或污渍、被子蓬松度明显下降保暖效果变差、距离上次清洗已超过2年。',
        },
      ],
      conclusion: '羽绒被的正确护理并不复杂，关键在于选择专业干洗服务和做好日常维护。科学护理的羽绒被可以使用10年以上，始终保持出色的保暖性能和蓬松柔软的手感。',
    },
    faq: [
      { question: '羽绒被干洗后保暖性会变差吗？', answer: '专业羽绒干洗不会影响保暖性。关键在于使用温和溶剂和低温烘干，保留羽绒天然油脂。不规范的干洗过度脱脂才会导致保暖性下降。' },
      { question: '羽绒被可以自己在家洗吗？', answer: '不建议。家用洗衣机容量有限，羽绒被吸水后重量大增，容易损坏机器。且家用烘干机温度控制不够精准，容易导致羽绒受损或烘干不彻底产生异味。' },
      { question: '羽绒被干洗一次多少钱？', answer: '根据被子大小和填充量，专业羽绒被干洗价格一般在150-400元之间。双人羽绒被约200-300元，特大号约300-400元。' },
    ],
  },
  {
    slug: 'meinvbei-ganxi-zhinan',
    title: '美女被干洗终极指南：高端被芯的专业护理之道',
    excerpt: '美女被以其精梳棉天丝混纺面料和奢华质感著称，正确的干洗护理能让其持久如新。本文为您揭秘美女被的专业干洗方案。',
    category: 'meinvbei',
    categoryName: '美女被干洗',
    date: '2026-07-10',
    readTime: '7分钟',
    author: '被护专家',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20luxury%20comforter%20with%20intricate%20jacquard%20weave%20pattern%20in%20cream%20and%20champagne%20tones%2C%20draped%20artfully%20on%20a%20premium%20bed%2C%20warm%20ambient%20lighting%2C%20sophisticated%20hotel%20suite%20setting%2C%20professional%20interior%20photography%2C%20rich%20fabric%20texture%20detail&width=800&height=500&seq=art-mnv-01&orientation=landscape',
    content: {
      intro: '美女被作为高端寝具的代表，采用优质精梳棉与天丝混纺面料精制而成，兼具丝绸般的光泽与棉质的亲肤透气。其独特的面料结构决定了它需要更专业的洗护方案。本文将全方位解析美女被的干洗护理要点，让您的爱被持久保持奢华质感。',
      sections: [
        {
          heading: '美女被的面料特性与洗护需求',
          content: '美女被采用的高支高密精梳棉与天丝混纺面料具有以下特点：面料密度高触感细腻柔滑、天然面料吸湿透气性极佳、混纺结构兼具两种纤维优点、对清洗方式比普通棉被更敏感。这些特性决定了美女被不能随意水洗——水洗会导致天丝纤维变硬、面料缩水率增大、光泽度大幅下降。专业干洗是保持美女被质感的最佳选择。',
        },
        {
          heading: '美女被专业干洗六步法',
          content: '第一步是全面检查与分类，区分面料成分和装饰工艺，确认适合的干洗方案。第二步是局部预处理，针对汗渍、化妆品残留等特殊污渍进行专业处理。第三步选择专用的温和干洗溶剂进行清洗。第四步低温慢烘，在40°C以下温度缓慢烘干。第五步手工精细整烫，恢复面料的自然光泽和垂坠感。第六步进行品质检查，确保无残留异味、面料无损伤，包装完好交付。',
        },
        {
          heading: '美女被日常护理三大原则',
          content: '第一原则是勤换被套，建议每周更换清洗被套，减少被芯直接接触污染源。第二原则是定期通风，每月在晴朗天气将被芯在通风阴凉处晾晒3-4小时，注意不可暴晒。第三原则是正确的收纳方式，换季收纳时使用纯棉透气收纳袋，放入薰衣草等天然防虫香料，存放于干燥洁净的衣柜上层。',
        },
        {
          heading: '选择美女被干洗服务的注意事项',
          content: '选择干洗服务商时请留意：确认干洗店有处理高档面料的经验和资质、询问使用何种干洗溶剂及设备品牌、了解是否提供独立的被芯清洗设备（避免与衣物混洗）、查看用户评价特别是高端寝具清洗的评价、确认是否有完善的售后保障和赔付机制。',
        },
      ],
      conclusion: '美女被是高端寝具中的艺术品，值得最专业的呵护。选择对的专业干洗服务、养成好的日常护理习惯，您的爱被将持续散发奢华魅力，为您打造星级酒店般的睡眠体验。',
    },
    faq: [
      { question: '美女被和普通棉被干洗有什么区别？', answer: '美女被采用精梳棉天丝混纺面料，对干洗溶剂和温度更敏感。需要使用更温和的专用溶剂，烘干温度更低，工艺流程更精细。价格通常比普通棉被干洗高出30%-50%。' },
      { question: '美女被干洗频率如何？', answer: '建议每12-18个月干洗一次。如果日常使用被套且保养得当，18个月一次即可。出现明显污渍或异味时应及时送洗。' },
      { question: '美女被干洗后会变硬吗？', answer: '专业干洗不会。选择有处理高档面料经验的干洗店，使用正确的溶剂和工艺，美女被干洗后依然保持柔软顺滑。变硬通常是使用了不当溶剂或烘干温度过高导致。' },
    ],
  },
  {
    slug: 'beixin-richang-baoyang',
    title: '被芯日常保养大全：5个习惯让被子多用3年',
    excerpt: '被芯的日常保养往往被忽视，但其实好的使用习惯才是延长被子寿命的关键。掌握这5个核心保养习惯，轻松让您的被芯多用3-5年。',
    category: 'beixin',
    categoryName: '被芯保养',
    date: '2026-07-05',
    readTime: '5分钟',
    author: '被护专家',
    image: 'https://readdy.ai/api/search-image?query=Well%20organized%20linen%20closet%20with%20neatly%20folded%20comforters%20and%20bedding%2C%20natural%20light%20from%20window%2C%20clean%20and%20fresh%20home%20organization%2C%20minimalist%20interior%20design%2C%20warm%20cream%20and%20beige%20palette%2C%20professional%20home%20care%20photography&width=800&height=500&seq=art-bx-01&orientation=landscape',
    content: {
      intro: '一套好的被芯动辄数千元，但很多家庭的被子用不了两三年就变得塌瘪、发黄、有异味。其实只要养成科学的日常保养习惯，您完全可以让被芯的使用寿命延长3-5年，甚至更久。今天就来分享5个超实用的被芯保养习惯。',
      sections: [
        {
          heading: '习惯一：被套是您的第一道防线',
          content: '被套不仅仅是装饰品，更是被芯最重要的保护层。选择纯棉高支高密被套（60支以上），能有效阻挡汗渍、皮脂和灰尘渗入被芯。建议准备2-3套被套轮换使用，每周更换清洗一次。这样可以将被芯的干洗周期从半年延长到1-2年，大大降低保养成本。',
        },
        {
          heading: '习惯二：科学晾晒是关键',
          content: '不同材质的被芯对晾晒的要求各不相同：蚕丝被和羽绒被应在通风阴凉处晾晒，避免阳光直射破坏蛋白纤维，每次2-3小时即可。棉被可以在温和阳光下晾晒3-4小时，有助于杀菌除螨。毛毯类建议平铺晾晒避免悬挂变形，阴凉通风处晾2-3小时。所有被芯晾晒后都应收进室内再降温，避免热被芯吸入湿气。',
        },
        {
          heading: '习惯三：正确收纳决定被芯寿命',
          content: '换季收纳是被芯保养的重中之重。首先确保被芯完全干燥再收纳，任何残留湿气都会导致发霉。收纳袋选择纯棉透气材质，避免使用塑料袋或真空压缩袋。在收纳空间放置天然防虫防潮剂如竹炭包、薰衣草香包。被芯应放在衣柜上层干燥通风处，远离地面和墙壁。每隔1-2个月将被芯取出通风散潮一次。',
        },
        {
          heading: '习惯四：发现小问题及时处理',
          content: '局部小污渍不要等到大面积扩散才处理。发现污渍后立即用干净湿布轻拍（不要揉搓），吸走表面污渍。然后尽快送专业干洗店进行局部处理，避免污渍渗透固化。发现面料有开线或小破损应及时修补，防止破损扩大导致填充物外漏。',
        },
        {
          heading: '习惯五：定期翻转使用',
          content: '长期固定使用同一面会导致被芯填充物不均匀分布。建议每月将被芯上下翻转一次，每季度头尾对调一次。这样可以让填充物受力均匀，避免局部塌陷。对于羽绒被和蚕丝被尤为重要，能有效防止填充物向四周跑偏。',
        },
      ],
      conclusion: '被芯保养不需要花费太多时间和精力，关键在于养成好的习惯并持之以恒。这5个简单的保养习惯，能帮您省下频繁更换被芯的费用，更重要的是，为您和家人创造一个更健康舒适的睡眠环境。',
    },
    faq: [
      { question: '被芯可以用吸尘器清洁吗？', answer: '可以，但需使用配有织物刷头的吸尘器，以最低档位轻柔吸除表面灰尘。不要用力按压，避免将被芯填充物吸移位。建议每月吸尘一次。' },
      { question: '被芯有霉味怎么办？', answer: '在晴朗干燥天气将被芯放在通风处晾晒4-6小时，然后轻拍表面。如果霉味严重，说明内部可能已滋生霉菌，建议尽快送专业干洗处理。' },
      { question: '收纳时可以用樟脑丸吗？', answer: '不建议。樟脑丸气味强烈且含有化学成分，可能与被芯面料发生反应。建议使用天然防虫产品如薰衣草香包、雪松木块等。' },
    ],
  },
  {
    slug: 'ganxi-fuwu-zenme-xuan',
    title: '干洗服务怎么选？5个标准帮你找到靠谱干洗店',
    excerpt: '市面上干洗店良莠不齐，选错干洗店可能毁掉您心爱的被子。本文教您5个关键评判标准，轻松识别靠谱的专业干洗服务商。',
    category: 'meinvbei',
    categoryName: '美女被干洗',
    date: '2026-07-01',
    readTime: '6分钟',
    author: '被护专家',
    image: 'https://readdy.ai/api/search-image?query=Professional%20dry%20cleaning%20store%20interior%20with%20modern%20equipment%2C%20clean%20organized%20space%2C%20staff%20handling%20textiles%20carefully%2C%20bright%20white%20and%20stainless%20steel%20aesthetic%2C%20professional%20service%20environment%2C%20warm%20lighting%2C%20commercial%20photography&width=800&height=500&seq=art-fuwu-01&orientation=landscape',
    content: {
      intro: '选对干洗店和被芯本身一样重要。一个不专业的干洗操作，可能让您几千元买来的蚕丝被或羽绒被毁于一旦。那么如何在众多干洗店中找到真正靠谱的专业服务商呢？本文总结5个核心评判标准，帮您做出明智选择。',
      sections: [
        {
          heading: '标准一：看资质与设备',
          content: '专业的干洗店应具备合法的营业执照和相关行业资质认证。更关键的是设备——高端全封闭式干洗机能够精确控制溶剂温度、洗涤时间和烘干温度，对娇贵面料尤为重要。进店时可以观察设备成色和维护状况，干净整洁的设备是专业度的直观体现。优先选择使用国际知名品牌设备的干洗店，如意大利ILSA、德国BOWE等。',
        },
        {
          heading: '标准二：了解干洗溶剂类型',
          content: '干洗溶剂直接关系到清洗效果和对被芯的影响。目前主流干洗溶剂有石油溶剂（碳氢溶剂）和四氯乙烯两种。对于蚕丝被、羽绒被等娇贵被芯，石油溶剂是更安全的选择，因为它性质温和，不会损伤天然蛋白纤维。进店时可以主动询问使用的溶剂类型，专业店铺会坦率告知并解释原因。',
        },
        {
          heading: '标准三：是否有独立被芯清洗线',
          content: '这是很多人容易忽略但非常重要的评判点。被芯体积大、吸水性强，与日常衣物混洗容易造成交叉污染和设备过载。专业的干洗店应配备专用于被芯、毛毯等大件寝具的独立清洗设备。可以询问：我家被子是和别人衣服一起洗的吗？专业店铺会明确告知有独立的大件清洗流程。',
        },
        {
          heading: '标准四：看用户口碑与评价',
          content: '在大众点评、小红书等平台查看真实用户评价，重点关注：高端寝具清洗经验的评价、是否有洗坏赔付的案例记录、客户的回头率和推荐意愿。注意分辨刷评——真实评价通常有具体细节描述而非笼统的好评。同时可以咨询周边邻居朋友的口碑推荐。',
        },
        {
          heading: '标准五：售后服务与赔付机制',
          content: '再专业的干洗店也有小概率出现意外。靠谱的店铺会主动告知清晰的赔付标准和流程。在送洗前当场确认被芯状况并拍照留证，明确了解损坏赔付标准和流程。正规店铺应该有保价服务和明确的赔付条款，而不是含糊其辞。',
        },
      ],
      conclusion: '选对干洗店等于给您的被子买了份保险。花点时间按照这5个标准考察筛选，您一定能找到值得信赖的专业干洗服务商，让昂贵的被芯得到应有品质的护理。',
    },
    faq: [
      { question: '连锁干洗店一定比个体店好吗？', answer: '不一定。连锁店的优势在于标准化流程和品牌保障，但个体老店往往拥有更丰富的经验和更灵活的服务。关键看实际专业度而非品牌大小。' },
      { question: '干洗价格越贵越好吗？', answer: '价格高不一定代表质量好，但价格过低的干洗店很可能在溶剂质量、设备维护等环节偷工减料。建议选择中等偏上价位的专业店铺。' },
      { question: '网上预约上门取送的干洗服务靠谱吗？', answer: '选择有实体店支撑、评价体系完善的O2O干洗平台是可以信赖的。但纯线上无实体店的需谨慎，最好确认其合作干洗工厂的资质和设备情况。' },
    ],
  },
  {
    slug: 'maotan-qingxi-yanghu',
    title: '毛毯清洗养护全知道：不同材质的专属护理方案',
    excerpt: '羊毛毯、羊绒毯、珊瑚绒毯……不同材质的毛毯需要不同的清洗方式。学会区分和正确护理，让您的毛毯始终柔软如新。',
    category: 'maotan',
    categoryName: '毛毯清洗',
    date: '2026-06-25',
    readTime: '6分钟',
    author: '被护专家',
    image: 'https://readdy.ai/api/search-image?query=Various%20luxurious%20blankets%20in%20different%20textures%20and%20materials%20elegantly%20displayed%2C%20wool%20cashmere%20and%20fleece%20varieties%2C%20soft%20natural%20lighting%2C%20cozy%20home%20setting%2C%20premium%20textile%20photography%2C%20cream%20and%20warm%20neutral%20tones&width=800&height=500&seq=art-mao-01&orientation=landscape',
    content: {
      intro: '毛毯是秋冬季节的家居必备品，既可作为盖毯取暖，也能作为沙发装饰增添温馨感。然而不同材质的毛毯对清洗护理的要求差异很大，用错方法可能导致毛毯缩水、起球甚至变形。本文将分材质为您详细解读各种毛毯的正确清洗和保养方法。',
      sections: [
        {
          heading: '羊毛毯的清洗与保养',
          content: '羊毛毯是最需要小心对待的品类。羊毛纤维表面有鳞片结构，遇水遇热容易毡化缩水。因此羊毛毯必须采用专业干洗，严禁水洗和机洗。日常保养时每周用软毛刷顺着毛向轻刷去除表面灰尘。局部脏污用湿毛巾蘸取少量羊毛专用清洁剂轻拍处理。收纳时需放入防虫剂，因为羊毛是蛀虫的最爱。',
        },
        {
          heading: '羊绒毯的精细护理',
          content: '羊绒毯比羊毛毯更娇贵，纤维更细更柔软。羊绒毯同样只能干洗，且需要选择有羊绒护理经验的干洗店。日常护理中避免频繁折叠同一位置造成折痕。使用后轻轻抖落表面灰尘即可。收纳时平铺存放而非折叠，可卷起来放入透气收纳袋，避免重压导致绒毛倒伏。',
        },
        {
          heading: '珊瑚绒与法兰绒毯的清洗',
          content: '珊瑚绒和法兰绒属于化纤类毛毯，耐洗性较好。可以机洗但需注意：选择轻柔模式、水温不超过30°C、使用中性洗涤剂、不可使用柔顺剂（会堵塞纤维间隙影响蓬松度）。烘干选择低温模式，高温会导致绒毛硬化。这类毛毯性价比高，正常使用可每季度清洗一次。',
        },
        {
          heading: '混纺毛毯的清洗原则',
          content: '混纺毛毯需按其中最娇贵成分的标准来护理。例如羊毛混纺需按羊毛标准处理（干洗），棉麻混纺偏棉质可水洗。如果不确定成分，宁可选择更保守的清洗方式。查看洗涤标签是判断清洗方式最直接的途径。洗涤标签上圆圈中有P或F代表可干洗，有手在水中的图案代表可水洗。',
        },
      ],
      conclusion: '毛毯的种类繁多，但护理原则只有一个——根据最娇贵的成分来选择清洗方式。当不确定时，专业干洗永远是最安全的选择。正确的清洗护理能让您喜爱的毛毯保持多年的柔软舒适。',
    },
    faq: [
      { question: '毛毯可以暴晒除螨吗？', answer: '不可以。紫外线会使羊毛和羊绒纤维变脆发黄。除螨可以选择在通风阴凉处晾晒4-6小时，或者使用专业的除螨仪进行物理除螨。' },
      { question: '毛毯起球了怎么办？', answer: '轻微起球是正常现象，使用毛球修剪器轻轻修剪即可。频繁严重起球可能是清洗方式不当或毛毯品质问题，建议更换清洗方式或联系商家。' },
      { question: '羊毛毯干洗后会缩水吗？', answer: '专业羊毛干洗不会缩水。干洗是在无水环境下使用溶剂清洗，羊毛纤维不会吸水膨胀。缩水通常是水洗或使用了不当烘干方式导致的。' },
    ],
  },
];

export const articlesByCategory = (slug: string) => allArticles.filter((a) => a.category === slug);

export const featuredArticles = allArticles.slice(0, 4);

export const recentArticles = allArticles.slice(0, 6);

export const brandInfo = {
  name: '被护专家',
  tagline: '专业被芯干洗护理品牌',
  description: '被护专家成立于2015年，是国内领先的专业被芯干洗护理服务品牌。我们拥有10年以上被芯护理经验的技师团队，配备意大利进口全封闭干洗设备，累计服务超过50万家庭。从蚕丝被到羽绒被，从美女被到羊毛毯，我们为每一件被芯提供量身定制的洗护方案。',
  story: '品牌创始人张女士曾在某国际五星级酒店担任客房总监十余年，深知一床好被子对睡眠品质的重要性。回国后发现国内缺少专业的被芯护理服务，许多家庭因为清洗不当导致昂贵被芯提前报废。本着让每个家庭都能享受专业被芯护理的初心，张女士创立了被护专家品牌。',
  features: [
    { icon: 'ri-award-line', title: '10年+经验', desc: '技师团队平均从业经验超过10年' },
    { icon: 'ri-building-line', title: '50万+家庭', desc: '累计为超过50万家庭提供被芯护理服务' },
    { icon: 'ri-shield-check-line', title: '百万保额', desc: '每件被芯送洗即享百万级保险保障' },
    { icon: 'ri-recycle-line', title: '环保溶剂', desc: '全线使用国际认证环保干洗溶剂' },
  ],
  testimonials: [
    {
      name: '李女士',
      location: '北京朝阳',
      text: '结婚时买的蚕丝被用了5年一直不知道该怎么洗，朋友推荐被护专家后果断送洗。拿回来的时候简直像新的一样，蓬松柔软，一点缩水都没有，太惊喜了！',
      rating: 5,
    },
    {
      name: '王先生',
      location: '上海浦东',
      text: '家里的羽绒被用了两年有些异味，抱着试试看的心态送洗了一次。结果出乎意料地好，羽绒完全恢复了蓬松，异味也彻底消失了。已经推荐给好几个同事了。',
      rating: 5,
    },
    {
      name: '赵女士',
      location: '广州天河',
      text: '我最满意的就是他们的服务流程很透明，送洗前当面检查拍照，取件时一一对照。这种专业态度让人很放心，美女被交给他们护理很安心。',
      rating: 5,
    },
    {
      name: '陈先生',
      location: '深圳南山',
      text: '之前在一家普通干洗店洗坏了一条羊毛毯，有心理阴影了。朋友力荐被护专家，抱着试试看的心态去了，确实专业！技师详细解释了羊毛毯的护理原理，取回来果然毛发无损，以后就认定这家了。',
      rating: 5,
    },
  ],
  contact: {
    phone: '400-888-6666',
    email: 'service@beizhuanjia.com',
    address: '上海市浦东新区张江高科技园区碧波路888号',
    hours: '周一至周日 9:00 - 21:00',
  },
};

export const serviceSteps = [
  {
    step: 1,
    icon: 'ri-search-eye-line',
    title: '专业检测',
    desc: '技师仔细检查被芯面料成分、填充物类型和污渍情况，制定专属洗护方案',
  },
  {
    step: 2,
    icon: 'ri-drop-line',
    title: '局部预处理',
    desc: '针对顽固污渍使用专业去渍剂进行温和预处理，不损伤面料纤维',
  },
  {
    step: 3,
    icon: 'ri-contrast-drop-2-line',
    title: '专业干洗',
    desc: '采用意大利进口全封闭干洗设备，低温短时洗涤，保护纤维结构',
  },
  {
    step: 4,
    icon: 'ri-sun-line',
    title: '低温烘干',
    desc: '分阶段低温缓慢烘干，确保被芯内外干燥均匀，不伤填充物',
  },
  {
    step: 5,
    icon: 'ri-brush-3-line',
    title: '整形恢复',
    desc: '手工拍打恢复蓬松度，精整边角和线迹，让被芯焕然一新',
  },
  {
    step: 6,
    icon: 'ri-check-double-line',
    title: '品质检验',
    desc: '多重质检确保无异味、无损伤、蓬松度达标，精美包装交付',
  },
];